/**
 *
 * @author Nandhini Narasimhan @ 02/05/2018 12:36
 * @description
 * @notes
 */
import React, {Component} from "react"

import id from "@irati/utils/id"
import {AnalysisContext} from "@irati/insights/context"

import CommentsController from "./CommentsController"

class Comments extends Component {
  render() {
    const idNamespace = id("Comments", this.props)

    return (
      <AnalysisContext.Consumer>
        {({filters, schedule, tenantId: tenant}) => {
          return (
            <CommentsController
              id={idNamespace}
              filters={filters}
              cycle={schedule}
              tenant={tenant} />
          )
        }}
      </AnalysisContext.Consumer>
    )
  }
}

export default Comments
